import React from "react";
import CollectionReportView from "./report/CollectionReportView";
import PackagesSubscriptionCountView from "./report/PackageswiseSubscriptionCountView";
import ProfitView from "./report/ProfitView";
import RevenueAndExpensesView from "./report/RevenueAndExpensesView";
import SubscriptionAndCollectionView from "./report/SubscriptionAndCollectionView";
import SubscriptionReportView from "./report/SubscriptionReportView";
import GeoChart from "./report/MapChartView";

const DashboardView = () => {
  return (
    <div className="flex-1 mt-4 p-6 bg-gray-100 min-h-screen overflow-auto">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 mb-4">
        <div className="bg-subtle shadow-md rounded-lg p-6">
          <h2 className="text-lg font-semibold mb-2">Collection</h2>
          <CollectionReportView />
        </div>
        <div className="bg-subtle shadow-md rounded-lg p-6">
          <h2 className="text-lg font-semibold mb-2">Subscription</h2>
          <SubscriptionReportView />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        <div className="bg-subtle shadow-md rounded-lg p-6">
          <h2 className="text-lg font-semibold mb-2">Revenue and Expenses</h2>
          <RevenueAndExpensesView />
        </div>
        <div className="bg-subtle shadow-md rounded-lg p-6">
          <h2 className="text-lg font-semibold mb-2">
            Subscription and Collection
          </h2>
          <SubscriptionAndCollectionView />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        <div className="bg-subtle shadow-md rounded-lg p-6">
          <h2 className="text-lg font-semibold mb-2">Packages Subscription</h2>
          <PackagesSubscriptionCountView />
        </div>
        <div className="bg-subtle shadow-md rounded-lg p-6">
          <h2 className="text-lg font-semibold mb-2">Profit</h2>
          <ProfitView />
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4">
        <div className="bg-subtle shadow-md rounded-lg p-6">
          <h2 className="text-lg font-semibold mb-2">
            State wise Subscription
          </h2>
          <GeoChart />
        </div>
      </div>
    </div>
  );
};

export default DashboardView;
